import { formatISO, isBefore, parseISO, subDays } from "date-fns";
import { Period } from "./documentFulfillment/types";

export type MigrationRequiredPeriod = Period & { end: string };

export function migrationRequiredPeriod(args: {
    migrationStartDate: string | null | undefined;
    bookkeepingStartDate: string | null | undefined;
}): MigrationRequiredPeriod | null {
    const { migrationStartDate, bookkeepingStartDate } = args;
    if (!bookkeepingStartDate) {
        return null;
    }
    const end = formatISO(subDays(parseISO(bookkeepingStartDate), 1), {
        representation: "date",
    });
    const start = migrationStartDate ?? null;
    if (start && isBefore(parseISO(end), parseISO(start))) {
        return null;
    }
    return { start, end };
}
